import React from "react";
import Features from "../components/Vitt Vichaar/features";
import Cta from "../components/Vitt Vichaar/cta";
import Cards from "../components/Vitt Vichaar/cards";
import VideoCards from "../components/Vitt Vichaar/videos";
import VittMarquee from "../components/Vitt Vichaar/vitt-marquee";
import VittHero from "../components/Vitt Vichaar/hero";
import Plus from "../components/Vitt Vichaar/plus";

export default function VittVichaar() {
  return (
    <>
      <div className="py-12 px-8">
        <VittHero />
      </div>
      <VittMarquee />
      <Features />
      <Plus />
      <VideoCards />
      <Cards />
      <Cta />
    </>
  );
}
